import React, { useCallback } from 'react';

const readFileAsBase64 = file => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  return new Promise(resolve => {
    reader.onloadend = () => resolve(reader.result);
  });
};

const readImg = async (files, sizeLimit) => {
  if (files === null)
    return {
      ext: '',
      image: null,
      error: 'hasNoFiles',
    };

  const img = files?.length ? files[0] : files;

  if (img && img.size > sizeLimit) return { ext: '', image: null, error: 'fileSizeExceed' };

  try {
    const result = await readFileAsBase64(img);
    return ({ ext: img.type, image: img, error: null, base64: result })
  } catch (err) {
    return { ext: '', image: null, error: 'someError' };
  }


  // if (typeof result === 'string') {
  //   const arr = result.split(',');
  //   const extension = arr[0].match(/(jpeg|png|jpg|gif|webp)/i);

  //   if (!extension) return { ext: '', image: null, error: 'fileReadError' };
  //   const ext = extension[0];
  //   const image = result;
  //   // const image = arr[1];

  //   return {
  //     ext,
  //     image,
  //     error: null,
  //   };
  // }

  // return { ext: '', image: null, error: 'someError' };
};

const useImageInput = ({ sizeLimit }) => useCallback(async files => {
    const imageData = await readImg(files, sizeLimit);
    return imageData;
  }, []);

export default useImageInput;
